/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Appearance_DescriptionInputs */

const en_settings_appearance_description = /** @type {(inputs: Settings_Appearance_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personalize the appearance of your app.`)
};

const es_settings_appearance_description = /** @type {(inputs: Settings_Appearance_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Personaliza la apariencia de tu aplicación.`)
};

/**
* | output |
* | --- |
* | "Personalize the appearance of your app." |
*
* @param {Settings_Appearance_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const settings_appearance_description = /** @type {((inputs?: Settings_Appearance_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Appearance_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_settings_appearance_description(inputs)
	return en_settings_appearance_description(inputs)
});